import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Coins, Target, ShoppingCart, X } from "lucide-react";

interface ZeroCreditsDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function ZeroCreditsDialog({ open, onOpenChange }: ZeroCreditsDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <button
                    onClick={() => onOpenChange(false)}
                    className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
                >
                    <X className="h-4 w-4" />
                    <span className="sr-only">Fechar</span>
                </button>
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <Coins className="h-5 w-5 text-yellow-500" />
                        Seus créditos acabaram!
                    </AlertDialogTitle>
                    <AlertDialogDescription className="space-y-3">
                        <p>
                            Você não possui mais créditos para gerar novos vídeos.
                        </p>
                        <p className="font-medium text-foreground">
                            Escolha como deseja continuar:
                        </p>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <div className="flex flex-col sm:flex-row gap-2 mt-4">
                    <Button variant="outline" className="w-full sm:w-auto" asChild>
                        <Link to="/dashboard/tasks" className="flex items-center justify-center gap-2">
                            <Target className="h-4 w-4" />
                            Fazer Missões
                        </Link>
                    </Button>
                    <Button className="w-full sm:w-auto" asChild>
                        <Link to="/dashboard/creditos" className="flex items-center justify-center gap-2">
                            <ShoppingCart className="h-4 w-4" />
                            Comprar Créditos
                        </Link>
                    </Button>
                </div>
                <Button
                    variant="ghost"
                    className="w-full mt-2 text-muted-foreground"
                    onClick={() => onOpenChange(false)}
                >
                    Agora não
                </Button>
            </AlertDialogContent>
        </AlertDialog>
    );
}
